// import { fetchBannerList } from '@/api/index'
// import { post } from '@/utils/fetch'
import indexService from '@/api/indexService'
import newsService from '@/api/newsService'
const state = {
    // 轮播图列表
    bannerList: [],
    // 业务板块内容
    businessUnitList: [],
    // 核心产品
    coreProductList: [],
    // 新闻列表
    newsList: []
}
const mutations = {
    // 设置轮播图列表
    SET_BANNER_LIST: (state, data) => {
        state.bannerList = data.list || []
    },
    // 设置业务板块列表
    SET_BUSINESS_UNIT_LIST: (state, data) => {
        state.businessUnitList = data.list || []
    },
    // 设置核心产品列表
    SET_CORE_PRODUCT_LIST: (state, data) => {
        state.coreProductList = data.list || []
    },
    // 设置新闻列表
    SET_NEWS_LIST: (state, data) => {
        state.newsList = data.list || []
    }
}
const actions = {
    // 获取轮播图列表
    getBannerList({ commit }, params) {
        return new Promise((resolve, reject) => {
            indexService.fetchBannerList(params)
                .then(res => {
                    resolve(res)
                    const { data } = res
                    commit('SET_BANNER_LIST', data)
                })
        })
    },
    // 获取业务板块
    getBusinessUnitList({ commit }, params) {
        return new Promise((resolve, reject) => {
            indexService.fetchBusinessUnitList(params)
                .then(res => {
                    resolve(res)
                    const { data } = res
                    commit('SET_BUSINESS_UNIT_LIST', data)
                })
        })
    },
    // 获取核心产品列表
    getCoreProductList({ commit }, params) {
        return new Promise((resolve, reject) => {
            indexService.fetchCoreProductList(params)
                .then(res => {
                    resolve(res)
                    const { data } = res
                    commit('SET_CORE_PRODUCT_LIST', data)
                })
        })
    },
    // 获取新闻列表
    getNewsList({ commit }, params) {
        return new Promise((resolve, reject) => {
            newsService.fetchNewsList(params)
                .then(res => {
                    resolve(res)
                    const { data } = res
                    commit('SET_NEWS_LIST', data)
                })
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js